<template>
    <nav class="sidebar-nav">
        <SidebarNavItem to="/bankwatch/users" icon="user" title="Manage Users" />
        <SidebarNavItem to="/bankwatch/user-products" icon="database" title="User Products" />
        <SidebarNavItem to="/bankwatch/market-products" icon="shop" title="Market Products" />
        <SidebarNavItem to="/bankwatch/alerts" icon="bell" title="Alerts" />
        <SidebarNavItem to="/bankwatch/broker-groups" icon="team" title="Broker Groups" />
        <SidebarNavItem to="/bankwatch/notices" icon="bell" title="Platform Notices" />
        <SidebarNavItem to="/bank-categories" icon="tags" title="Bank Categories" />
        <SidebarNavItem to="/product-blacklist" icon="stop" title="Product Blacklist" />
    </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SidebarNavItem from './SidebarNavItem.vue';

export default defineComponent({
    name: 'BankWatchSidebar',
    components: {
        SidebarNavItem
    }
});
</script>

<style lang="scss" scoped>
.sidebar-nav {
    display: flex;
    flex-direction: column;
}

.nav-section-header {
    text-align: center;
    padding: 16px 8px 8px 8px;
    margin: 12px 8px 0 8px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);

    span {
        color: rgba(255, 255, 255, 0.8);
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
    }
}
</style>
